import { ChatComposeBoxAddAttachmentMenuItem } from '@glade-ai/chat-plugin/ui';
import { type ComponentPropsWithoutRef, forwardRef } from 'react';

import { useLoom } from '@/providers/Loom/LoomProvider';
import { type MediaApiModels } from '@/tsClient/servers/noodleMedia';

const ADD_VIDEO_LABEL = 'Video';
const ADD_VIDEO_ICON = 'ph--video--regular';

const ADD_LOOM_VIDEO_LABEL = 'Record Loom Video';
const ADD_LOOM_VIDEO_ICON = 'ph--record--regular';

export const AddVideoMenuItem = forwardRef<
  HTMLDivElement,
  Omit<ComponentPropsWithoutRef<typeof ChatComposeBoxAddAttachmentMenuItem>, 'icon' | 'label'>
>((props, forwardedRef) => (
  <ChatComposeBoxAddAttachmentMenuItem {...props} ref={forwardedRef} icon={ADD_VIDEO_ICON} label={ADD_VIDEO_LABEL} />
));
AddVideoMenuItem.displayName = 'AddVideoMenuItem';

type AddLoomVideoMenuItemProps = Omit<
  ComponentPropsWithoutRef<typeof ChatComposeBoxAddAttachmentMenuItem>,
  'icon' | 'label'
> & {
  onAttachLoomMedia?: (media: MediaApiModels.Media) => void;
  jobCorrelationId?: string;
};

export const AddLoomVideoMenuItem = forwardRef<HTMLDivElement, AddLoomVideoMenuItemProps>(
  ({ onAttachLoomMedia, jobCorrelationId, ...props }, forwardedRef) => {
    const { isLoomSupported, recordVideo } = useLoom();

    if (!isLoomSupported) return null;

    return (
      <ChatComposeBoxAddAttachmentMenuItem
        {...props}
        ref={forwardedRef}
        icon={ADD_LOOM_VIDEO_ICON}
        label={ADD_LOOM_VIDEO_LABEL}
        onClick={(e) => {
          recordVideo({
            jobCorrelationId,
            onAttachLoomMedia,
          });
          props.onClick?.(e);
        }}
      />
    );
  },
);
AddLoomVideoMenuItem.displayName = 'AddLoomVideoMenuItem';
